import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewEncapsulation, NgZone } from '@angular/core';
import { GridApi, ColDef } from 'ag-grid-community';
// Models
import { MultipleApiResponse, Vehicle } from '@mocca-technologies/model';

import { CoreService } from 'src/app/services/core.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-maintenance-table',
  templateUrl: './maintenance-table.component.html',
  styleUrls: ['./maintenance-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MaintenanceTableComponent  implements OnInit {

  /**
   * Variables
   */
  vehicleList: Vehicle[];

  @Input() maintenanceType: 'battery' | 'drone' = 'battery';

  rows = [
    { date: new Date('2023-01-01'), startPercentage: 100, endPercentage: 50, meanTemperature: 25, returnHomePower: 55, landingPower: 52, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-02'), startPercentage: 90, endPercentage: 45, meanTemperature: 26, returnHomePower: 48, landingPower: 46, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-03'), startPercentage: 85, endPercentage: 40, meanTemperature: 24, returnHomePower: 43, landingPower: 41, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-04'), startPercentage: 80, endPercentage: 35, meanTemperature: 27, returnHomePower: 38, landingPower: 36, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-05'), startPercentage: 75, endPercentage: 30, meanTemperature: 23, returnHomePower: 33, landingPower: 31, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-06'), startPercentage: 70, endPercentage: 25, meanTemperature: 22, returnHomePower: 28, landingPower: 26, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-07'), startPercentage: 65, endPercentage: 20, meanTemperature: 21, returnHomePower: 23, landingPower: 21, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-08'), startPercentage: 60, endPercentage: 15, meanTemperature: 20, returnHomePower: 18, landingPower: 16, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-09'), startPercentage: 55, endPercentage: 10, meanTemperature: 19, returnHomePower: 13, landingPower: 11, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-10'), startPercentage: 50, endPercentage: 5, meanTemperature: 18, returnHomePower: 8, landingPower: 6, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-11'), startPercentage: 45, endPercentage: 0, meanTemperature: 17, returnHomePower: 5, landingPower: 3, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-12'), startPercentage: 40, endPercentage: 5, meanTemperature: 16, returnHomePower: 8, landingPower: 6, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-13'), startPercentage: 35, endPercentage: 10, meanTemperature: 15, returnHomePower: 13, landingPower: 11, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-14'), startPercentage: 30, endPercentage: 15, meanTemperature: 14, returnHomePower: 18, landingPower: 16, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-15'), startPercentage: 25, endPercentage: 20, meanTemperature: 13, returnHomePower: 23, landingPower: 21, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-16'), startPercentage: 20, endPercentage: 25, meanTemperature: 12, returnHomePower: 28, landingPower: 26, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-17'), startPercentage: 15, endPercentage: 30, meanTemperature: 11, returnHomePower: 33, landingPower: 31, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-18'), startPercentage: 10, endPercentage: 35, meanTemperature: 10, returnHomePower: 38, landingPower: 36, drone: "UPC012 - DJI Matrice 350 RTK" },
    { date: new Date('2023-01-19'), startPercentage: 5, endPercentage: 40, meanTemperature: 9, returnHomePower: 43, landingPower: 41, drone: "UPC011 - DJI Matrice 300 RTK" },
    { date: new Date('2023-01-20'), startPercentage: 0, endPercentage: 45, meanTemperature: 8, returnHomePower: 48, landingPower: 46, drone: "UPC011 - DJI Matrice 300 RTK" }
  ];

  columnsBatteryLog: ColDef[] = [
    { field: 'date', headerName: 'Date', filter: true, flex: 2 },
    { field: 'startPercentage', headerName: 'Start Percentage', filter: true, flex: 1 },
    { field: 'endPercentage', headerName: 'End Percentage', filter: true, flex: 1 },
    { field: 'meanTemperature', headerName: 'Mean Temperature', filter: true, flex: 1 },
    { field: 'returnHomePower', headerName: 'Return Home Power', filter: true, flex: 1 },
    { field: 'landingPower', headerName: 'Landing Power', filter: true, flex: 1 },
    { field: 'drone', headerName: 'Drone', filter: true, flex: 2 },
  ];

  logType = 'pilot';

  // ag-grid configuration
  pagination = true;
  paginationPageSize = 5;
  paginationPageSizeSelector = [5, 10, 50];
  gridApi: GridApi;
  localeText: any;

  constructor(private coreService: CoreService, private translateService: TranslateService, private ngZone: NgZone) {}

  ngOnInit() {
    this.updateLocaleText();

    // Subscribe to language change events
    this.translateService.onLangChange.subscribe(() => {
      this.ngZone.run(() => {
        this.updateLocaleText();
      });
    });

    this.coreService.getAllVehicles().subscribe({
      next: (res: HttpResponse<MultipleApiResponse>) => {

        if (res?.status === 204){
          this.vehicleList = [];
          return;
        }

        this.vehicleList = res?.body?.responseObject as Vehicle[];
      },
      error: error => {
        this.coreService.showServerResponse(error?.status, error?.error);
      }
    });
  }

  /**
   * Check if current screen is mobile view
   */
  isMobileView(): boolean {
    return window.innerWidth < 600;
  }

  /**
   * Update locale text for ag-grid
   */
  private updateLocaleText(): void {
    this.localeText = {
      page: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.PAGE'),
      to: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.TO'),
      of: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.OF'),
      more: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.MORE'),
      next: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.NEXT'),
      last: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.LAST'),
      first: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.FIRST'),
      previous: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.PREVIOUS'),
      loadingOoo: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.LOADING'),
      noRowsToShow: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.NO_ROWS'),
      filterOoo: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.FILTER'),
      equals: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.EQUALS'),
      notEqual: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.NOT_EQUAL'),
      lessThan: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.LESS_THAN'),
      greaterThan: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.GREATER_THAN'),
      contains: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.CONTAINS'),
      notContains: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.NOT_CONTAINS'),
      startsWith: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.STARTS_WITH'),
      endsWith: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.ENDS_WITH'),
      andCondition: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.AND'),
      orCondition: this.translateService.instant('PAGES.LOGBOOKS.DATATABLE.OR'),
    };
  }

  /**
   * Grid ready event handler
   */
  onGridReady(params: any): void {
    this.gridApi = params.api;
  }

}
